export const common = {
  exactLogo: require('assets/images/exact.png'),
  backGroundImage: require('assets/images/background_image.png'),
  nablLogo: require('assets/images/NABL.png'),
  tableIcon: require('assets/images/cells.png'),
};
